// ADD NEW ADDRESS JS FUNCTIONALITY ---------------------------------------

const body = document.querySelector(" body ");
const addTrigger = document.querySelector(" .add-address-btn ");
const addForm = document.querySelector('[js-addresses="newForm"]');
const contentToggle = document.querySelector('[js-addresses="contentToggle"]');
const cancelTrigger = document.querySelector(" .cancel-add-address ");

// console.log(addTrigger);
// console.log(addForm);
if (addTrigger && addForm) {
  // Open New Address Form
  addTrigger.addEventListener("click", (e) => {
    if (addForm.classList.contains("active")) {
      return;
    } else {
      addForm.classList.add("active");
      contentToggle.classList.remove("active");
      addTrigger.classList.add("active");
    }
  });
}

if (cancelTrigger && addForm && addTrigger) {
  // Close New Address Form
  cancelTrigger.addEventListener("click", (e) => {
    if (addForm.classList.contains("active")) {
      addForm.classList.remove("active");
      addTrigger.classList.remove("active");
      contentToggle.classList.add("active");
    } else {
      return;
    }
  });
}

//-------------------------------------------------------------------------

// EDIT ADDRESS JS FUNCTIONALITY ------------------------------------------

const editTrigger = document.querySelectorAll('[js-addresses="editAddress"]');

if (editTrigger) {
  // Close Edit Address Form
  editTrigger.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      // console.log( 'Edit Button', btn.closest('.address-card').querySelector('.edit-mask') );
      // console.log( 'Edit Button Closest: ', btn.closest('.address-card') );
      // body.classList.add("locked");
/*      btn
        .closest(".address-card")
        .querySelector(".edit-mask")
        .classList.add("active");*/
      const formId = btn.getAttribute('data-form-id');
      contentToggle.classList.remove("active");
      document.getElementById(`EditAddress_${formId}`).classList.add('active')
    });
  });
}

const cancelEdit = document.querySelectorAll('[js-addresses="cancelEdit"]');

if (cancelEdit) {
  // Close Edit Address Form
  cancelEdit.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      btn.closest(".template-addresses__form").classList.remove("active");
      contentToggle.classList.add("active");
    });
  });
}

// DELETE ADDRESS JS FUNCTIONALITY ------------------------------------------

const deleteAddresses = document.querySelectorAll('[js-addresses="deleteAddress"]');

deleteAddresses.forEach((btn) => {
  btn.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    const formId = event.currentTarget.getAttribute('data-form-id');
    window.Shopify.postLink('/account/addresses/' + formId, {
      parameters: { _method: 'delete' }
    });
  })
});


